import React from 'react'
import { Box } from '@mui/material'
import {
  PageContainer,
  PagePaper,
  PageHeader,
  PageTitle,
  PageSubtitle,
} from './AdminPageWrapper.styled'

interface AdminPageWrapperProps {
  title: string
  subtitle?: string
  children: React.ReactNode
  actions?: React.ReactNode
}

export const AdminPageWrapper: React.FC<AdminPageWrapperProps> = ({
  title,
  subtitle,
  children,
  actions,
}) => (
  <PageContainer maxWidth='lg'>
    <PagePaper>
      <PageHeader
        display='flex'
        justifyContent='space-between'
        alignItems='flex-start'
      >
        <Box>
          <PageTitle>{title}</PageTitle>
          {subtitle && <PageSubtitle>{subtitle}</PageSubtitle>}
        </Box>
        {actions && <Box>{actions}</Box>}
      </PageHeader>
      {children}
    </PagePaper>
  </PageContainer>
)
